import {
  AuthenticationRequiredMessage,
  LoadingIndicatorMessage,
  NoResultMessage,
  NoUserActionMessage,
  ServerErrorMessage,
  UserActionRequiredMessage,
} from "@sgwt-widget/components-base";
import { Status } from "common/types/global";
import { h } from "preact";

interface StatusLine {
  status: Status;
  reason?: string;
}

export const StatusLine = ({
  status,
  reason,
}: StatusLine): JSX.Element | null => {
  switch (status) {
    case "init":
    case "loaded":
      return null;
    case "emptyInput":
      return <UserActionRequiredMessage message={reason || ""} />;
    case "empty":
      return <NoResultMessage />;
    case "loading":
      return <LoadingIndicatorMessage />;

    case "error": {
      const isAuthError = /unauthorized/i.test(reason || "");
      return isAuthError ? (
        <AuthenticationRequiredMessage />
      ) : reason ? (
        <NoUserActionMessage message={"Server Error: " + reason} />
      ) : (
        <ServerErrorMessage />
      );
    }
    default:
      throw Error();
  }
};
